import React, { createContext, useContext, Component } from "react";

export const BookContext = createContext(null);

class BookProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      book: {},
      currentChapter: {},
      loadingChunk: false,
    };
  }

  componentDidMount() {
    this.getBook();
  }

  getBook() {
    const { book } = this.props;
    if (!book) return;

    const newBook = {
      ...book,
      chapters: (book.chapters || []).map((chapter, i) => ({
        ...chapter,
        audioUrl: `${chapter.audioUrl}`,
      })),
    };

    this.setState({
      book: newBook,
      currentChapter: newBook.chapters[0] || {},
    });
  }

  setCurrentChapter = (chapter) => {
    this.setState({ currentChapter: chapter });
  };

  setLoadingChunk = (loading) => {
    this.setState({ loadingChunk: loading });
  };

  render() {
    return (
      <BookContext.Provider
        value={{
          book: this.state.book,
          currentChapter: this.state.currentChapter,
          setCurrentChapter: this.setCurrentChapter,
          loadingChunk: this.state.loadingChunk,
          setLoadingChunk: this.setLoadingChunk,
        }}
      >
        {this.props.children}
      </BookContext.Provider>
    );
  }
}

const useBookContext = () => useContext(BookContext);

export { BookProvider, useBookContext };